<template>
    <div
        class="touchRange"
        @mousedown="triggered = true"
        @mouseup="triggered = false"
        @mouseleave="triggered = false"
        @click="touchmove($event, false)"
        @mousemove="touchmove($event, true)"
        @touchmove="touchmove($event, false)">
        <div
            class="touchRange__progress"
            :style="{ 'width': progress + '%' }">
        </div>
    </div>
</template>

<style lang="sass" scoped>
.touchRange
    background-color: lightgray
    height: 7.5px
    width: 100%
    border-radius: 5px
    overflow: hidden

    &__progress
        height: 100%
        background-color: var(--primary)
        border-radius: 5px
        transition: width .25s ease
</style>

<script>
    /**
     * @see {@link https://github.com/miyaoka/vue-touch-range}
     */
    export default {
        name: 'TouchRange',
        props: {
            value: {
                type: Number,
                default: 0
            },
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 1
            },
            step: {
                type: [ Number, String ],
                default: 'any'
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        data: () => ({
            triggered: false
        }),
        computed: {
            range() {
                return this.max - this.min
            },
            progress() {
                return (this.value / this.max) * 100
            }
        },
        methods: {
            touchmove(e, needTrigger) {
                if (needTrigger && !this.triggered)
                    return

                e.preventDefault()
                const cw = this.$el.clientWidth
                const pageX = e.touches ? e.touches[0].pageX : e.layerX
                const rate = Math.max(0, Math.min(cw, pageX)) / cw
                const value = rate * this.range + this.min
                this.$emit('input', Math.round(value))
            }
        }
    }
</script>
